(function () {
  if (window.__sndCartCmpInit) return;
  window.__sndCartCmpInit = true;

  function getSectionId() {
    var el = document.querySelector('cart-items-component');
    return el && el.dataset.sectionId ? el.dataset.sectionId : 'cart-drawer-section';
  }

  function handleAdd(btn) {
    var id = parseInt(btn.dataset.variantId, 10);
    if (!id) return;

    var text = btn.querySelector('.snd-cart-cmp__add-text');
    var added = btn.querySelector('.snd-cart-cmp__added-text');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: id, quantity: 1 }],
        sections: getSectionId(),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data && data.status) {
          throw new Error(data.description || data.message || 'Cart error');
        }
        if (text) text.hidden = true;
        if (added) added.hidden = false;
        var card = btn.closest('.snd-cart-cmp__item');
        if (card) {
          // Horizontal rail: collapse the card's width so neighbours slide in.
          card.style.width = card.offsetWidth + 'px';
          card.style.flex = '0 0 auto';
          card.style.transition = 'opacity .2s ease, width .22s ease .12s, padding .22s ease .12s, margin .22s ease .12s, border-width .22s ease .12s';
          card.style.overflow = 'hidden';
          card.style.opacity = '0';
          requestAnimationFrame(function () {
            card.style.width = '0';
            card.style.paddingInline = '0';
            card.style.marginInlineEnd = '-10px'; /* swallow the flex gap */
            card.style.borderWidth = '0';
          });
          setTimeout(function () { card.remove(); }, 400);
        }
        setTimeout(function () {
          if (text) text.hidden = false;
          if (added) added.hidden = true;
          btn.disabled = false;
        }, 2200);
      })
      .catch(function (err) {
        btn.disabled = false;
        console.error('[soundium-cart-complementary]', err);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-snd-cart-cmp-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    handleAdd(btn);
  });
})();
